export function buildTelefone(ddd, numero) {
  return {
    ddd: ddd ?? '',
    numero: numero ?? '',
  };
}
export default buildTelefone;
